// extracted by mini-css-extract-plugin
export default {"bodyNetworkWraper":"NetworkBodySetting_bodyNetworkWraper__RF4GL"};